import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import WhiteButton from "../../common_components/common_button/WhiteButton";
import "../step1/Step.css";
import "./Step.css";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  CreatePersonalDetail_Step2,
  GetStepsDetail,
} from "../../../features/admin/kycverification/kyc/Slice";
import { AllCity } from "../../../features/admin/common/Slice";
import Select from "react-select";
import { getUserId } from "../../../utils/authUser";

const user_id = getUserId();

const Step2 = ({ formData, setFormData, onNext, onBack }) => {
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: formData,
  });

  const dispatch = useDispatch();

  const all_cities = useSelector((state) => state?.common?.all_cities);

  const stepDetail = useSelector(
    (state) => state?.kycverification?.kyc?.stepdetail,
  );

  const [isPrefilled, setIsPrefilled] = useState(false);

  useEffect(() => {
    dispatch(AllCity());
  }, [dispatch]);

  useEffect(() => {
    if (stepDetail && all_cities?.length && !isPrefilled) {
      const personal = stepDetail?.kyc_personal_details;

      if (personal) {
        reset({
          full_name: personal.full_name,
          date_of_birth: personal.date_of_birth,
          street_address: personal.street_address,
          zipcode: personal.zipcode,
          othercity: personal.othercity || "",
          city_id:
            all_cities.find((city) => city.value === personal.city_id) || null,
        });

        setIsPrefilled(true);
      }
    }
  }, [stepDetail, all_cities, reset, isPrefilled]);

  const onSubmit = (data) => {
    const payload = {
      user_id,
      full_name: data.full_name,
      date_of_birth: data.date_of_birth,
      street_address: data.street_address,
      city_id: data.city_id?.value,
      zipcode: data.zipcode,
      othercity: data.othercity || null,
    };

    dispatch(CreatePersonalDetail_Step2(payload)).then((res) => {
      if (res?.payload) {
        setFormData(data);
        onNext();
      }
    });
  };

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const maxDate = yesterday.toISOString().split("T")[0];

  return (
    <section className="step1-section step2-section">
      <div className="title-section">
        <h2 className="step1-title">Step 02: Personal & Address Details</h2>
        <p className="step1-subtitle">
          Please enter your personal and address details exactly as shown on
          your ID.
        </p>
      </div>

      <div className="step1-form">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-4">
            <Form.Label className="select_title">
              Full name (as per ID)
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="eg. sarah jamdar"
              className="rounded-pill"
              // ✅ Prevent typing numbers & symbols
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
              }}
              {...register("full_name", {
                required: "Name is required",

                // ✅ Validation (extra safety)
                pattern: {
                  value: /^[A-Za-z\s]+$/,
                  message: "Only alphabets are allowed",
                },
              })}
            />

            {errors.full_name && (
              <Form.Text className="text-danger">
                {errors.full_name.message}
              </Form.Text>
            )}
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="select_title">Date of Birth</Form.Label>
            <Form.Control
              type="date"
              max={maxDate}
              {...register("date_of_birth", {
                required: "Date of birth is required",
                validate: (value) =>
                  new Date(value) <= new Date(maxDate) ||
                  "Future date is not allowed",
              })}
            />

            {errors.date_of_birth && (
              <Form.Text className="text-danger">
                {errors.date_of_birth.message}
              </Form.Text>
            )}
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="select_title">Street address</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              {...register("street_address", {
                required: "Street address is required",
                maxLength: {
                  value: 100,
                  message: "Street address cannot exceed 100 characters",
                },
              })}
            />

            {errors.street_address && (
              <Form.Text className="text-danger">
                {errors.street_address.message}
              </Form.Text>
            )}
          </Form.Group>

          <Row className="mb-4">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="select_title">City</Form.Label>

                <Controller
                  name="city_id"
                  control={control}
                  rules={{ required: "City is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={all_cities}
                      value={field.value}
                      onChange={(val) => field.onChange(val)}
                      onInputChange={(val) => {
                        dispatch(AllCity(val));
                      }}
                    />
                  )}
                />

                {errors?.city_id && (
                  <Form.Text className="text-danger">
                    {errors?.city_id?.message}
                  </Form.Text>
                )}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-4">
                <Form.Label className="select_title">
                  Other City (Optional)
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter other city"
                  {...register("othercity", {
                    maxLength: {
                      value: 15,
                      message: "Other City cannot exceed 15 characters",
                    },
                  })}
                />

                {errors.othercity && (
                  <Form.Text className="text-danger">
                    {errors.othercity.message}
                  </Form.Text>
                )}

                {/* {errors.othercity && (
                    <Form.Text className="text-danger">
                      {errors.othercity.message}
                    </Form.Text>
                  )} */}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="select_title">Zipcode</Form.Label>

                <Form.Control
                  type="text"
                  placeholder="eg. 413501"
                  maxLength={6} // ✅ restrict length
                  // ✅ allow only numbers while typing
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                  {...register("zipcode", {
                    required: "Zipcode is required",

                    pattern: {
                      value: /^[0-9]{6}$/, // ✅ EXACTLY 6 digits
                      message: "Zipcode must be exactly 6 digits",
                    },
                  })}
                />

                {errors.zipcode && (
                  <Form.Text className="text-danger">
                    {errors.zipcode.message}
                  </Form.Text>
                )}
              </Form.Group>
            </Col>
          </Row>

          <p className="text-danger text-center fw-semibold">
            Please ensure details match your government-issued ID.
          </p>

          <div className="center-btn d-flex justify-content-center gap-3">
            <WhiteButton
              className="white-bt"
              title="Back"
              bg="#fff"
              color="#000"
              onClick={onBack}
            />

            <WhiteButton
              className="black-bt"
              title="Save & Next"
              bg="#000"
              color="#f35f37"
              hoverBg="#000"
              hoverColor="#f35f37"
              type="submit"
            />
          </div>
        </Form>
      </div>
    </section>
  );
};

export default Step2;
